/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author JiHoon Park
 * @contact jhpark@detech.co.kr
 * @date 2022-07-19
 * @brief EHP 자동완성 개발
 *
 ********************************************************************/
import React, { useState } from "react";
/**
 * @brief EHP 자동완성 컴포넌트
 * @param -
 * @returns react components
 */
function AutoComplete(props) {
    const wordList = props.workList; //autofield
    const autoInfo = props.autoInfo;
    const setParentAutoInfo = props.setAutoInfo;
    const resetParentAutoInfo = props.resetAutoInfo;
    const errorList = props.errorList;
    const errorField = props.errorField;
    const initKeyword = props.hasOwnProperty("initKeyword") ? props.initKeyword : "";
    const [keyword, setKeyword] = useState(initKeyword);
    function handleSelectKeyword(e, autoInfo) {
        setKeyword("");
        setParentAutoInfo(autoInfo);
    }
    function handleOnChange(e) {
        resetParentAutoInfo();
        setKeyword(e.target.value);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("input", { type: "text", id: "inp4", className: (errorList) && (errorList.filter(err => (err.field === errorField)).length > 0) ? "input-error" : "", placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694", value: (autoInfo) ? autoInfo.autofield : keyword, onChange: (e) => handleOnChange(e) }),
        React.createElement("p", { className: "input-errortxt" }, (errorList) && errorList.filter(err => (err.field === errorField)).map((err) => err.msg)),
        React.createElement("ul", { className: "autocomplete-box", style: { "display": `${(keyword.length > 0) ? "" : "none"}` } }, wordList.filter(word => (word.autofield.toUpperCase().includes(keyword.toUpperCase()))).map((word, idx) => (React.createElement("li", { key: `autofield_${idx.toString()}`, onClick: (e) => handleSelectKeyword(e, word) },
            React.createElement("a", { href: "#" },
                word.autofield.substring(0, word.autofield.toUpperCase().indexOf(keyword.toUpperCase())),
                React.createElement("span", { className: "highlight" }, word.autofield.substring(word.autofield.toUpperCase().indexOf(keyword.toUpperCase()), word.autofield.toUpperCase().indexOf(keyword.toUpperCase()) + keyword.length)),
                word.autofield.substring(word.autofield.toUpperCase().indexOf(keyword.toUpperCase()) + keyword.length))))))));
}
export default AutoComplete;
